import React from "react";
import Button from "./Button";
import logo from "../img/CoinGecckoLogo.png";

function customAlert(msg, duration) {
  const styler = document.createElement("div");
  styler.setAttribute("role", "alert");
  styler.setAttribute("class", "alert alert-dark fade show");
  styler.setAttribute(
    "style",
    "position: absolute; top: 0; right: 0; width: 175px; height: 50px; text-align:right;"
  );
  styler.innerHTML = "<p>" + msg + "</p>";
  setTimeout(function () {
    styler.parentNode.removeChild(styler);
  }, duration);
  document.body.appendChild(styler);
}
function caller() {
  customAlert("Copied to clipboard", "2000");
}

const Footer = () => {
  const copyclip = () => {
    const vote = "6W8yrMwtDU5G6ErazhZHfLjqZV8cMvajpSRGYgrZ3d4v";
    navigator.clipboard.writeText(vote);
    caller();
  };

  return (
    <footer className="footer mt-auto py-3 bg-dark fixed-bottom">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8 text-start text-muted">
            Support this project by donating to
            <span className="pe-2" id="vote" style={{ color: "DodgerBlue" }}>
              {" "}
              4h5jgXFaWZVpUA4LMWAecvXnZxCMwqzMgmrrKSm6RYaS
            </span>
            <Button
              cname="btn btn-outline-light btn-sm padding"
              text="Copy"
              onClick={copyclip}
            />
          </div>

          <div className="col text-end">
            <span className="text-muted">
              <a
                className="mr-5"
                href="https://www.coingecko.com/en"
                target="_blank"
                rel="noreferrer"
              >
                Powered by CoinGecko
              </a>
              <img src={logo} alt="" width="30" height="30" />
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
